import { useQuery } from "@apollo/client/react";import React, { useCallback, useMemo, useState } from 'react';

import Searcher from './Searcher';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { adaptDelegacionArray } from '../../../../../../adapters/delegacionAdapter';
import { adaptUsuariosParsedByTipoArray, GET_USUARIOS_PAGINADOS } from '../../../../../../data/graphQL/queries/usuarios/getUsuariosPaginados';

const storageId = sessionStorage.getItem('idUsuario');

const UsuarioField = ({
  onChange,
  idResponsableAccion,
  disabled,
  idDelegacion
}) => {
  const CONFIGURATED_COLUMNS = useMemo(() => generateColumnsDefaultConfiguration(columns), [columns, idResponsableAccion]);

  const buildFilters = (filterValue) => {
    if (!filterValue) return null;

    // Divide el valor en palabras
    const terms = filterValue.trim().split(/\s+/);

    // Si solo hay un término, busca en todos los campos relevantes individualmente
    if (terms.length === 1) {
      return {
        or: [
        { nombre: { contains: terms[0] } },
        { apellido: { contains: terms[0] } }]

      };
    }

    // Si hay más de un término, busca cada palabra en todos los campos relevantes sin agrupar
    return {
      and: terms.map((term) => ({
        or: [
        { nombre: { contains: term } },
        { apellido: { contains: term } }]

      }))
    };
  };

  const getSearchParams = useCallback((textValue) => {
    const filterDelegacion = {
      t_SecUsuarioDelegacion: {
        some: { idDelegacion: { eq: idDelegacion } }
      },
      activo: { eq: true }
    };

    const searchParams = {
      and: [filterDelegacion]
    };

    if (textValue) {
      searchParams.and.push({
        or: [
        textValue ? buildFilters(textValue) ?? {} : {},
        parseInt(textValue) > 0 ? { idUsuario: { eq: parseInt(textValue) } } : {}]

      });
    }

    return searchParams;
  }, [idDelegacion]);

  const handleRowClick = (row) => {
    const value = !!row ? row.idUsuario : null;
    onChange('idResponsableAccion', value);
  };

  const getEntityValue = (row) => {
    const value = !!row ? `${row.idUsuario} - ${row.nombre} ${row.apellido}` : null;
    return value;
  };

  return <Searcher
    displayName='Responsable de Acción'
    titleModal='Seleccionar usuario'
    entityName='allUsuarios'
    entityId='idUsuario'
    entityIdValue={idResponsableAccion}
    columns={CONFIGURATED_COLUMNS}
    query={GET_USUARIOS_PAGINADOS}
    adapter={adaptUsuariosParsedByTipoArray}
    getSearchParams={getSearchParams}
    onRowClick={handleRowClick}
    getEntityValue={getEntityValue}
    disabled={disabled} />;

};

export default UsuarioField;

const columns = [
{ field: 'idUsuario', headerName: 'Id', flex: 8 },
{ field: 'usuario', headerName: 'Usuario', flex: 12 },
{ field: 'apellido', headerName: 'Apellido', flex: 14 },
{ field: 'nombre', headerName: 'Nombre', flex: 14 },
{ field: 'email', headerName: 'Email', flex: 24 }];